import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Drawer from "components/common/Drawer";
const StyledDrawer = styled(Drawer)`
  .mantine-Drawer-body {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
`;
const AddWidgetDrawer = ({ children = void 0, onClose }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(
    StyledDrawer,
    {
      onClose,
      position: "right",
      size: "66%",
      title: t("add_widget_drawer.title"),
      closeOnClickOutside: false
    },
    children
  );
};
export default AddWidgetDrawer;
